module.exports = __webpack_public_path__ + "static/other/gameRideMechanic.5acd1142.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameRideMechanic.json
// module id = 2637
// module chunks = 0